import { Link } from "react-router-dom";
import xicon from "../../assets/images/x_icon.png"



const UserFooter = () => {
    return (
        <>
            <div className="footer-section section" style={{ backgroundColor: '#2075d6' }}>
                <div className="container">
                    {/* Footer Top Widgets Start */}
                    <div className="row">
                        {/* Footer Widget Start */}
                        <div className="col-xl-4 col-md-5 col-12 max-mb-50">
                            <div className="footer-widget">
                                <h4 className="footer-widget-title text-white jakarta">Callforatech Services &amp; Solutions</h4>
                                <div className="footer-widget-content">
                                    <div className="content">
                                        <p className="jakarta" style={{ color: '#fff' }}>At Home&Office Computers we are dedicated to client service and real IT solutions for Businesses and Residences. .</p>
                                        {/* <p>+1 (305) 547-9909 (9am - 5pm EST, Monday - Friday) </p>
                                      <p><a href="#">info@example.com </a></p> */}
                                    </div>
                                    <div className="footer-social-inline">
                                        <div className="text-center mt-4 mb-4" style={{ gap: 2 }}>
                                            <a href="https://x.com/callforatech?t=O_aeJhxG-93yekXd7ircdQ&s=08" target="_blank" style={{ backgroundColor: '#7f72e4', borderRadius: '50%', width: 35, height: 35, position:"absolute", bottom:"9px" }}>
                                                {/* <i style={{ fontSize: 20, marginTop: 9 }} className="fab fa-twitter text-white" /> */}
                                                <img
                                                    src={xicon}
                                                    alt="X"
                                                    // style={{position: 9\ }}
                                                />
                                            </a>
                                            <a href="https://www.facebook.com/callforatech" target="_blank" style={{ backgroundColor: '#7f72e4', borderRadius: '50%', width: 35, height: 35, marginLeft:"46px" }}>
                                                <i style={{ fontSize: 20, marginTop: 7 }} className="fab fa-facebook text-white" />
                                            </a>
                                            <a href="https://www.instagram.com/callforatech.com_services/profilecard/?igsh=MXAwdmxyMjZ5OHRrZw==" target="_blank" style={{ backgroundColor: '#7f72e4', borderRadius: '50%', width: 35, height: 35 }}>
                                                <i style={{ fontSize: 20, marginTop: 8 }} className="fab fa-instagram text-white" />
                                            </a>
                                            <a href="https://www.tiktok.com/@callforatech0?_t=8riwu7h6tmS&_r=1" target="_blank" style={{ backgroundColor: '#7f72e4', borderRadius: '50%', width: 35, height: 35 }}>
                                                <i style={{ fontSize: 20, marginTop: 9 }} className="fab fa-tiktok text-white" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Footer Widget End */}
                        {/* Footer Widget Start */}
                        {/* <div className="col-xl-2 col-md-4 col-sm-7 col-12 max-mb-50">
                            <div className="footer-widget">
                                <h4 className="footer-widget-title text-white jakarta">Resources</h4>
                                <div className="footer-widget-content">
                                    <ul className>
                                        <li><a className="jakarta" style={{ color: '#ffffff99' }} href="#">Testimonials</a></li>
                                        <li><a className="jakarta" style={{ color: '#ffffff99' }} href="#">Our Instructors</a></li>
                                        <li><a className="jakarta" style={{ color: '#ffffff99' }} href="#">ICDL Modules</a></li>
                                        <li><a className="jakarta" style={{ color: '#ffffff99' }} href="#">Certification</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div> */}
                        {/* Footer Widget End */}
                        {/* Footer Widget Start */}
                        <div className="col-xl-3 col-md-4 col-sm-7 col-12 max-mb-50">
                            <div className="footer-widget">
                                <h4 className="footer-widget-title text-white jakarta">Quick Links</h4>
                                <div className="footer-widget-content">
                                    <ul className>
                                        <li><a className="jakarta" style={{ color: '#fff' }} href="#">About Us</a></li>
                                        <li><a className="jakarta" style={{ color: '#fff' }} href="#">Contact Us</a></li>
                                        <li><a className="jakarta" style={{ color: '#fff' }} href="#">Get Certified</a></li>
                                        {/* <li><a className="jakarta" style={{ color: '#ffffff99' }} href="#">Enroll Now</a></li> */}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-4 col-sm-7 col-12 max-mb-50">
                            <div className="footer-widget">
                                <h4 className="footer-widget-title text-white jakarta">Have a Question?</h4>
                                <div className="footer-widget-content">
                                    <ul className>
                                        <li>
                                            <a
                                                className="jakarta"
                                                style={{ color: '#fff' }}
                                                href="tel:+16105725362"
                                            >
                                                <i className="fa fa-phone" /> &nbsp; +16105725362
                                            </a>
                                        </li>
                                        <li><a className="jakarta" style={{ color: '#fff' }} href="#"><i className="fa fa-paper-plane" /> &nbsp; sales@callforatech.com</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* Footer Widget End */}
                    </div>
                    {/* Footer Top Widgets End */}
                    {/* Footer Copyright Start */}
                    <div className="row max-mt-20">
                        <div className="col">
                            <p className="copyright text-white">Powered by Callforatech</p>
                        </div>
                    </div>
                    {/* Footer Copyright End */}
                </div>
            </div>
        </>
    );
}

export default UserFooter;